export default "__VITE_PUBLIC_ASSET__156fc930__"